import React from "react";
import styled from "styled-components";

const TermsAndConditions = () => {
  return (
    <Wrapper>
    <Card>
      <Title>Terms and Conditions</Title>

    <Section>
      <SectionTitle> 1. Introduction</SectionTitle>
      <Text>
        Welcome to <strong>CIANA HOME PRODUCTS LLP</strong>, a platform for Bathroom and Kitchen products. 
        By using our website, you agree to these terms.
      </Text>
    </Section>
     
    <Section>
      <SectionTitle> 2. Products</SectionTitle>
      <Text>
        We offer products such as wash basins, toilets, faucets, Kitchen sinks, mirror, floor-stainer, 
        clips & clamp and bathroom accessories. Product details may change without prior notice.
      </Text>
    </Section>

    <Section>
      <SectionTitle>3. Pricing & Payment</SectionTitle>
      <Text>
        All prices are in USD. We reserve the right to change prices at any time. 
        Payments must be completed through available methods.
      </Text>
    </Section>

    <Section>
      <SectionTitle>4. Orders</SectionTitle>
      <Text>
        We may cancel orders due to stock issues, pricing errors, or suspicious activity.
      </Text>
    </Section>

    <Section>
      <SectionTitle>5. Shipping</SectionTitle>
      <Text>
        Delivery times are estimates and may vary. We are not responsible for courier delays.
      </Text>
    </Section>

    <Section>
      <SectionTitle>6. Returns</SectionTitle>
      <Text>
        Returns are accepted only for damaged or incorrect items within 7 days of delivery. 
        Used products are not eligible.
      </Text>
    </Section>

    <Section>
      <SectionTitle>7. User Responsibility</SectionTitle>
      <Text>
        Users must provide accurate details and not misuse the platform.
      </Text>
    </Section>

    <Section>
      <SectionTitle>8. Intellectual Property</SectionTitle>
      <Text>
        All content on this website belongs to Your Store Name and cannot be
        reused without permission.
      </Text>
    </Section>

    <Section>
      <SectionTitle>9. Liability</SectionTitle>
      <Text>
        We are not responsible for any indirect damages from product usage.
      </Text>
    </Section>

    <Section>
      <SectionTitle>10. Governing Law</SectionTitle>
      <Text>This agreement is governed by the laws of India.</Text>
    </Section>

    <Section>
      <SectionTitle>11. Contact</SectionTitle>
      <Text>Email: info@cianahome.com</Text>
    </Section>
    </Card>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  background: ${({ theme }) => theme.colors.bgl};
  min-height: 100vh;
  padding: 40px 20px;
`;

const Card = styled.div`
  max-width: 800px;
  margin: auto;
  background: #ffff;
  padding: 3rem;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
`;

const Title = styled.h1`
  text-align: center;
  margin-bottom: 1rem;
  font-size: 2.5rem;
 `;

const Section = styled.div`
  margin-top: 25px;
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
`;

const Text = styled.p`
  margin-top: 8px;
  line-height: 1.8rem ;
  text-align: justify;
 `;

export default TermsAndConditions;